var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-dropdown',{attrs:{"text":'Filtra colonne',"variant":"none"}},_vm._l((_vm.columns.filter(function(o) {
            return ['__checkbox', '__sequence'].indexOf(o.name) === -1
        })),function(column,k){return _c('b-dropdown-item',{key:k,on:{"click":function($event){return _vm.toggleVisible(column)}}},[_vm._v(_vm._s(column.title !== undefined ? column.title : column.name))])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }